import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a86efe1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=a86efe1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86efe1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a86efe1c')) {
      api.createRecord('a86efe1c', component.options)
    } else {
      api.reload('a86efe1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a86efe1c&scoped=true", function () {
      api.rerender('a86efe1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monthly-credits-config/index.vue"
export default component.exports